import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { GraphUserSettingsService } from './../../services/graph/user-settings.service';
import { ApplicationInsightsService } from 'src/app/services/application-insights.service';

@Component({
	selector: 'app-video-player',
	templateUrl: './video-player.component.html',
	styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements AfterViewInit, OnDestroy {
	@Input() videoSrc: SafeUrl;
	@Input() captionSrc: SafeUrl;
	@Input() transcriptUrl: SafeUrl;
	@Input() showTranscript: boolean;
	@Input() videoName: string;
	@ViewChild('media', { static: true }) media: ElementRef<HTMLVideoElement>;
	public captionsOn: boolean;
	readonly skipSeconds = 10;
	hasVideoStarted = false;

	// Captions are toggled through the browser's native controls, so persist the choice whenever the track mode changes.
	private readonly onTextTracksChange = () => {
		const captionsShowing = Array.from(this.media.nativeElement.textTracks).some(track => track.mode === 'showing');
		if (captionsShowing !== this.captionsOn) {
			this.captionsOn = captionsShowing;
			this.userSettingsService.setUserSetting('captions', String(this.captionsOn));
		}
	};

	constructor(public translateService: TranslateService,
		private userSettingsService: GraphUserSettingsService,
		private applicationInsightsService: ApplicationInsightsService,
	) {
		this.captionsOn = this.userSettingsService.getUserSetting('captions') === 'true';
	}

	ngAfterViewInit() {
		this.media.nativeElement.textTracks.addEventListener('change', this.onTextTracksChange);
	}

	ngOnDestroy() {
		this.media.nativeElement.textTracks.removeEventListener('change', this.onTextTracksChange);
	}

	onPlay() {
		if (!this.hasVideoStarted) {
			this.hasVideoStarted = true;
			this.applicationInsightsService.logPageView(`Video`, this.videoName);
		}
	}

	skip(seconds: number) {
		const video = this.media.nativeElement;
		video.currentTime = Math.max(0, video.currentTime + seconds);
	}
}
